import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMediaQueryMatchesOnMobile } from '@as/cotopaxi';
import { ShoppingCartFillIcon } from '@yonderland/andes-icons';
import { ButtonAlpha, LinkButton, Stack } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { ProductAddToBasketLocations } from '../../enums/ActionEnums';
const PRODUCT_QUANTITY = 1;
export const PromoBasketPopupCTA = ({ addToBasket, closePopup }) => {
    const isMobile = useMediaQueryMatchesOnMobile();
    const { t } = useTranslation([I18N_NAMESPACES.checkout, I18N_NAMESPACES.product]);
    const onAddToBasketButtonClick = () => {
        addToBasket(PRODUCT_QUANTITY, ProductAddToBasketLocations.PROMO_BASKET_POPUP, true);
    };
    return (_jsxs(Stack, { direction: "col", gap: { base: '3', md: '4' }, children: [_jsx(ButtonAlpha, { fullWidth: true, theme: "branded", testId: "add_to_basket", size: isMobile ? 'sm' : 'md', onClick: onAddToBasketButtonClick, text: t('product:pdp.cart.addtobasket.btn'), iconLeft: { source: ShoppingCartFillIcon, size: isMobile ? 'xs' : 'sm' } }), _jsx(LinkButton, { onClick: closePopup, fullWidth: isMobile, children: t('checkout:basket.promo.popup.cancel') })] }));
};
